module.exports = __webpack_public_path__ + "img/4-5.e845c109.svg";